
import { useDispatch } from 'react-redux';
import { setMyFilesData } from '../actionCreators/myFiles';

export function ResetMyFiles() {
    const dispatch = useDispatch();

    dispatch(setMyFilesData([]));
}